require('./salon-search-ranks.scss')

module.exports = {
  template: require('./salon-search-ranks.pug')()
  controller: require('./salon-search-ranks.ctrl')
  bindings:
    salon: '='
}
